<template>
  <div class="ProjectOrderTable">
    <div class="section-title">基础信息</div>
    <table class="table">
      <tr>
        <td class="tableLabel">系统编号：</td>
        <td>{{repairRegistrationVo.billNo}}</td>
        <td class="tableLabel">接收日期：</td>
        <td>{{repairRegistrationVo.receiveTime}}</td>
        <td class="tableLabel">维修周期(天)：</td>
        <td>{{repairRegistrationVo.maintenanceCycle}}</td>
      </tr>
      <tr>
        <td class="tableLabel">条形码：</td>
        <td>{{repairRegistrationVo.barcode}}</td>
        <td class="tableLabel">原发货单号：</td>
        <td>{{repairRegistrationVo.oldDeliveryBillNo}}</td>
        <td class="tableLabel">售出月数：</td>
        <td>{{repairRegistrationVo.saleMonth}}</td>
      </tr>
      <tr>
        <td class="tableLabel">物料代码：</td>
        <td>{{repairRegistrationVo.materialNo}}</td>
        <td class="tableLabel">物料型号：</td>
        <td>{{repairRegistrationVo.materialName}}</td>
        <td class="tableLabel">数量：</td>
        <td>{{repairRegistrationVo.quantity}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户名称：</td>
        <td>{{repairRegistrationVo.customerName}}</td>
        <td class="tableLabel">是否保修：</td>
        <td>{{repairRegistrationVo.isWarranty ? '是' : '否'}}</td>
        <td class="tableLabel">是否收费：</td>
        <td>{{repairRegistrationVo.isCharge ? '是' : '否'}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户地址：</td>
        <td colspan="5">{{repairRegistrationVo.customerAddress}}</td>
      </tr>
      <tr>
        <td class="tableLabel">收货人：</td>
        <td>{{repairRegistrationVo.consignee}}</td>
        <td class="tableLabel">收货人电话：</td>
        <td>{{repairRegistrationVo.consigneeContact}}</td>
        <td class="tableLabel">返厂快递单号：</td>
        <td>{{repairRegistrationVo.returnCourierNO}}</td>
      </tr>
      <tr>
        <td class="tableLabel">发运快递单号：</td>
        <td>{{repairRegistrationVo.deliverCourierNO}}</td>
        <td class="tableLabel">发运人：</td>
        <td>{{repairRegistrationVo.deliverPeople}}</td>
        <td class="tableLabel">快递单位：</td>
        <td>{{repairRegistrationVo.deliverWay}}</td>
      </tr>
      <tr>
        <td class="tableLabel">3个月内维修次数：</td>
        <td>{{repairRegistrationVo.frequency}}</td>
        <td class="tableLabel">责任判定：</td>
        <td>{{repairRegistrationVo.responsibility}}</td>
        <td class="tableLabel">发运时间：</td>
        <td>{{repairRegistrationVo.deliverTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">硬件版本：</td>
        <td>{{repairRegistrationVo.hardwareVersion}}</td>
        <td class="tableLabel">软件版本：</td>
        <td>{{repairRegistrationVo.softwareVersion}}</td>
        <td class="tableLabel">历史报警：</td>
        <td>{{repairRegistrationVo.historicalAlarms}}</td>
      </tr>
      <tr>
        <td class="tableLabel">报修故障：</td>
        <td>{{repairRegistrationVo.faultReporting}}</td>
        <td class="tableLabel">实测故障：</td>
        <td>{{repairRegistrationVo.faultActual}}</td>
        <td class="tableLabel">是否完成工装测试：</td>
        <td>{{repairRegistrationVo.isWorkpieceTest ? '是' : '否'}}</td>
      </tr>
      <tr>
        <td class="tableLabel">更换配件：</td>
        <td>{{repairRegistrationVo.replacementParts}}</td>
        <td class="tableLabel">维修备注：</td>
        <td>{{repairRegistrationVo.note}}</td>
        <td class="tableLabel">维修人：</td>
        <td>{{repairRegistrationVo.repairName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">维修状态：</td>
        <td>{{repairRegistrationVo.status === 2 ? '已修' : repairRegistrationVo.status === 3 ? '已修' : repairRegistrationVo.status === 4 ? '疑难杂症' : repairRegistrationVo.status === 5 ? '技术分析' : repairRegistrationVo.status === 6 ? '报废' : ''}}</td>
        <td class="tableLabel">维修时间：</td>
        <td>{{repairRegistrationVo.repairTime}}</td>
        <td class="tableLabel">收费金额：</td>
        <td>{{repairRegistrationVo.chargedAmount}}</td>
      </tr>
    </table>
    
    <div class="section-title">维修明细</div>
    <el-table
        :data="repairRegistrationVo.details"
        border>
      <el-table-column prop="shapeCode" width="160" align="center" label="序列号"/>
      <el-table-column prop="replaceMaterialNo" width="160" align="center" label="更换物料"/>
      <el-table-column prop="faultActual" width="160" align="center" label="实测故障"/>
      <el-table-column prop="repairResult" width="160" align="center" label="检查结果"/>
      <el-table-column prop="faultDesc" width="160" align="center" label="故障描述"/>
      <el-table-column prop="specifications" width="160" align="center" label="型号"/>
      <el-table-column prop="problemType" width="160" align="center" label="问题分类"/>
      <el-table-column prop="note" width="160" align="center" label="备注"/>
      <el-table-column prop="positionNo" width="160" align="center" label="位号"/>
    </el-table>
    
    <div class="section-title">附件信息</div>
    <el-table
        v-if="repairRegistrationVo.attachments && repairRegistrationVo.attachments.length > 0"
        :data="repairRegistrationVo.attachments">
      <el-table-column type="index" align="center" label="行号" width="60"/>
      <el-table-column prop="fileName" align="center" label="图片">
        <template slot-scope="scope">
          <el-image
              style="width: 50px; height: 50px;margin-right: 10px"
              :src="scope.row.imgUrl"
              :preview-src-list="imgUrls"/>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" align="center" label="附件描述"/>
    </el-table>
    <div v-else style="text-align: center; color: #999; padding: 20px;">
      暂无附件
    </div>
  </div>
</template>

<script>
  export default {
    name: "RepairRegistrationCSPreview",
    data() {
      return {
        repairRegistrationVo: {
          details: [],
          attachments: [],
        },
        imgUrls: [],
      };
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        const billId = this.$route.query.billId;
        this.$http.get("basic", `repairRegistrations/${billId}`).then((resp) => {
          if (resp.success) {
            this.repairRegistrationVo = resp.data;
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  item.problemType = item.problemType.split("/");
                }
              });
            }
            // 处理附件URL
            this.repairRegistrationVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          }
        });
      },
      downLoad(url, name) {
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        link.click();
      },
    },
  };
</script>

<style scoped>
  .ProjectOrderTable {
    padding: 20px;
  }
  
  .section-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px 0;
    padding-bottom: 5px;
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .table tr {
    border-bottom: 1px solid #dfe6ec;
  }
  
  .table td {
    padding: 12px;
    border: 1px solid #dfe6ec;
    vertical-align: top;
  }
  
  .tableLabel {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: bold;
    width: 140px;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>